module.exports = __webpack_public_path__ + "img/water-rat.918c745d4682bbd391e723c47bef0dad.jpg";